import { createFileRoute, redirect } from "@tanstack/react-router";

/** Packs viven en Panel → Estado de plataforma (paridad Booking Hub). */
export const Route = createFileRoute("/admin/ops/packs")({
  beforeLoad: () => {
    throw redirect({ to: "/admin", search: { tab: "packs" } as never });
  },
});
